<template>
  <div class="detail-container">
    <div class="detail-header">
      <template v-if="getConfig.activationType !== 1">
        <img class="avatar" :src="authenticationInfo.photoUrl" />
      </template>
      <div class="content_info">
        <div>
          <div class="label">
            {{ getIdCardType(authenticationInfo.idCardType) }}
          </div>
          <div>{{ encryptIdCard(authenticationInfo.idCardNumber) }}</div>
          <div v-if="authenticationInfo.mobile">
            {{ encryptPhone(authenticationInfo.mobile) }}
          </div>
          <div>{{ authenticationInfo.name }}</div>
        </div>
        <div class="tag">
          <a-tag color="green" v-if="authenticationInfo.authenticated === 1">认证通过</a-tag>
          <a-tag color="red" v-if="authenticationInfo.activated === 1">激活通过</a-tag>
        </div>
      </div>
    </div>
    <div class="detail-content">
      <template v-if="receiptData.showQRCode">
        <Qrcode :src="QRCode" />
      </template>
      <p v-html="receiptData.displayConfiguration"></p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Qrcode from "@/components/QrCode.vue";
import {
  encryptIdCard,
  encryptPhone,
  getIdCardType,
  generateQR,
} from "@/utils/util";
export default {
  components: { Qrcode },
  data() {
    return {
      authenticationInfo: {},
      QRCode: "",
      receiptData: {
        showQRCode: false,
        displayConfiguration: "",
        code: "",
      },
    };
  },
  mounted() {
    const { alias, code } = this.$route.query;
    !!code &&
      this.getUserAuthenticationInfo(code) &&
      this.getUserReceiptData(alias, code);
  },
  computed: {
    ...mapGetters("activationStore", ["getConfig"]),
  },
  methods: {
    encryptIdCard,
    encryptPhone,
    getIdCardType,
    async getUserAuthenticationInfo(code) {
      const res = await this.$get(
        `/api/ActivationWeb/UserAuthenticationInfo?code=${code}`
      );
      if (res.code === 200) {
        this.authenticationInfo = { ...res.data };
      }
    },
    async getUserReceiptData(alias, code) {
      const res = await this.$get(
        `/api/ActivationWeb/UserReceiptData?alias=${alias}&code=${code}`
      );
      if (res.code === 200) {
        this.receiptData = res.data;
        if (res.data.showQRCode) {
          this.QRCode = await generateQR(res.data.code);
        }
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.detail-container {
  width: 100%;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
}
.detail-header {
  display: flex;
  min-height: 100px;
  padding: 10px;
  gap: 50px;
  justify-content: center;
}

.detail-header > .avatar {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 50%;
}

.detail-header > .avatar img {
  width: 100%;
  height: 100%;
}
.detail-header > .content_info {
  color: #838f8f;
  display: flex;
  flex-direction: column;
}
.detail-header > .content_info .label {
  color: #0030ab;
  font-size: 18px;
  font-weight: bold;
}

.detail-header > .content_info .tag {
  display: flex;
  justify-content: flex-end;
  margin-right: -50px;
}

.detail-content {
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
</style>
